module.exports = __webpack_public_path__ + "static/media/accIcon.8bf9b4ce.svg";